import { IonButton, IonCard, IonItem } from "@ionic/react"
import React from "react"
import FormBirthday from "./birthday"
import FormFirstName from "./first.name"
import FormGender from "./gender"
import FormLastName from "./last.name"

export interface Person {
  id: any
  firstName: string
  lastName: string
  birthday: string
  gender: string
}

interface Props {
  person: Person
  onDelete: () => void
  onChange: (person: Person) => void
}

const PersonCard: React.FC<Props> = (props) => {
  const onChange = (data: Partial<Person>) => {
    props.onChange({...props.person, ...data})
  }

  const onDelete = () => {
    props.onDelete()
  }

  return (
    <IonCard>
      <FormFirstName value={props.person.firstName} onChange={value => onChange({firstName: value})}/>
      <FormLastName value={props.person.lastName} onChange={value => onChange({lastName: value})}/>
      <FormGender value={props.person.gender} onChange={value => onChange({gender: value})} />
      <FormBirthday value={props.person.birthday} onChange={value => onChange({birthday: value})} />

      <IonItem>
        <IonButton fill="outline" onClick={onDelete} slot="end">Versicherte Person entfernen</IonButton>
      </IonItem>
    </IonCard>
  )
}

export default PersonCard
